var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.notification)?_c('v-snackbar',{attrs:{"color":_vm.notification.type,"bottom":""},model:{value:(_vm.notifyState),callback:function ($$v) {_vm.notifyState=$$v},expression:"notifyState"}},[_vm._v("\n  "+_vm._s(_vm.notification.message)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }